module.exports = __webpack_public_path__ + "static/valentinanastasev-fa9e99ff061bb9dbf0b7b8a4556c4384.png";